import {useQuery} from 'react-query';
import RateServiceApi from 'api/rate-service-api';
import {useMemo} from 'react';
import {HECMAvailableRatesQueryKey} from 'constants/query';

export function useHECMAvailableRatesQuery(props = {}) {
  const {enabled} = props;
  const {data: rates, status} = useQuery(HECMAvailableRatesQueryKey, () => RateServiceApi.getHECMRates(), {enabled});

  const data = useMemo(() => rates ?? [], [rates]);
  const defaultRate = useMemo(() => data.find((Rate) => Rate.IsDefault), [data]);

  return {data, defaultRate, status};
}
